import { type BaseDto, type Nullable } from "@pasta/box-v2";
import { NotificationType } from "../types";
import { type LetterFileTagDto } from "./letter-file-tag.dto";
import { type SignatureObjectDto } from "./signature.dto";

export enum MailingFrequency {
  NONE,
  ONCE_A_DAY,
  TWICE_A_DAY,
  REAL_TIME,
}

export enum LetterFileColor {
  GREEN = "GREEN",
  BLUE = "BLUE",
  YELLOW = "YELLOW",
  RED = "RED",
}

export interface UserPreferencesDto extends BaseDto {
  login: string;
  mailingFrequency: MailingFrequency;
  onboardingSeen: boolean;
  hideLetterFilesBefore?: string;
  signatureObjects: SignatureObjectDto[];
  color: LetterFileColor;
  job: string;
  city: string;
  enabledMailTypes: NotificationType[];
  lastSeenVersion: number;
  tags: LetterFileTagDto[];
  prepoWidth: number | null;
  prepoHeight: number | null;
  absentFrom: string | null;
  absentUntil: string | null;
  zoomLevel: number | null;
}

export interface WriteUserPreferencesDto {
  mailingFrequency?: MailingFrequency;
  onboardingSeen?: boolean;
  hideLetterFilesBefore?: Nullable<string>;
  color?: LetterFileColor;
  job?: string;
  city?: string;
  enabledMailTypes?: NotificationType[];
  lastSeenVersion?: number;
  tags?: number[];
  prepoWidth?: number;
  prepoHeight?: number;
  absentFrom?: string | null;
  absentUntil?: string | null;
  zoomLevel?: number | null;
}
